const sites = [
  {
    "id": "01",
    "url": "https://www.asianmhc.org/apisaa",
    "title": "Asian Mental Health Collective",
    "abbreviation": "AMHC"
  },
  {
    "id": "02",
    "url": "https://aahiinfo.org/aahi-resources/",
    "title": "Asian American Health Initiative",
    "abbreviation": "AAHI"  
  },
  {
    "id": "03",
    "url": "https://aapaonline.org/",
    "title": "Asian American Psychological Association",
    "abbreviation": "AAPA"  
  },  
  {
    "id": "04",
    "url": "https://www.naapimha.org/aanhpi-service-providers",
    "title": "National Asian American Pacific Islander Mental Health Association",
    "abbreviation": "NAAPIMHA"  
  },  
  {
    "id": "05",
    "url": "https://www.nqapia.org/wpp/healthandhealing/",
    "title": "National Queer Asian Pacific Islander Alliance",
    "abbreviation": "NQAPIA"  
  },  
  {
    "id": "06",
    "url": "https://www.nami.org/Your-Journey/Identity-and-Cultural-Dimensions/Asian-American-and-Pacific-Islander",
    "title": "National Alliance on Mental Illness",
    "abbreviation": "NAMI"  
  },  
  {
    "id": "07",
    "url": "http://www.asianmentalhealth.org/",
    "title": "New York Coalition for Asian American Mental Health",
    "abbreviation": "NYCAAMH"  
  },
  {
    "id": "08",
    "url": "https://samhin.org/resources/",
    "title": "South Asian Mental Health Initiative & Network",
    "abbreviation": "SAMHIN"  
  },  
  {
    "id": "09",
    "url": "https://aaspe.net/",
    "title": "Asian American Suicide Prevention & Education",
    "abbreviation": "AASPE"  
  },  
  {
    "id": "10",
    "url": "http://asianwomengivingcircle.org/",
    "title": "Asian Women Giving Circle",
    "abbreviation": "AWGC"
  }
];

export default sites;
